package kz.dentalcrm.app.screens.diagnosis.list.mvi

import kotlinx.collections.immutable.PersistentList
import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface DiagnosisViewSideEffect : ViewSideEffect {

    data class ShowEditService(val service: ServiceItem) :
        DiagnosisViewSideEffect

    data class ShowCategories(
        val serviceCategory: PersistentList<ServiceCategory>
    ) : DiagnosisViewSideEffect

}